"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASSIFICATION_COLORS = void 0;
exports.CLASSIFICATION_COLORS = {
    critical: '#ffa39e',
    high: '#ffd591',
    low: '#d3adf7',
    medium: '#ffe58f'
};
//# sourceMappingURL=CLASSIFICATION_COLORS.js.map